// src/api/healthcare/MeApi.ts
// The session bootstrap: GET /api/healthcare/me returns the signed-in user's profile and the clinic's subscriptions (contract §16.1).

import { http } from "../../lib/http/client";
import { ENV } from "../../config/runtimeEnv";
import type { User } from "../../types/admin/UserTypes";
import type { CompanySubscriptionData } from "../../types/admin/SubscriptionTypes";

export interface MeResponse {
	user: User;
	subscriptions: CompanySubscriptionData;
}

const EMPTY_SUBSCRIPTIONS: CompanySubscriptionData = { plans: [], features: [], available_roles: [] };

export const fetchMe = async (): Promise<MeResponse> => {
	const response = await http.get(`${ENV.VITE_HEALTHCARE_SERVER}/me`);
	const user = response.data?.user;
	// A profile without a uuid would leave the session keyed on nothing; refuse it rather than sign in half-way.
	if (!user || typeof user.uuid !== "string" || user.uuid === "") {
		throw new Error("The /me response carried no user uuid.");
	}
	return {
		user: { ...user, id: user.id ?? user.uuid },
		subscriptions: { ...EMPTY_SUBSCRIPTIONS, ...(response.data?.subscriptions ?? {}) },
	};
};
